export default __webpack_public_path__ + "static/media/latest-news-img34.2ad573b4.jpg";